import React from "react";
import { useParams, useHistory } from "react-router-dom";
import Event1 from "./Event1";
import Event2 from "./Event2";
import Event3 from "./Event3";
import Event4 from "./Event4";
import Event5 from "./Event5";
import Event6 from "./Event6";
import Event7 from "./Event7";
import Event8 from "./Event8";
import Event9 from "./Event9";
import Event10 from "./Event10";
import Event11 from "./Event11";
import Event12 from "./Event12";
import Event13 from "./Event13";
import Event14 from "./Event14";
import Event15 from "./Event15";
import Event16 from "./Event16";
import Event17 from "./Event17";
import Event18 from "./Event18";
import Event19 from "./Event19";
import Event20 from "./Event20";
import Event21 from "./Event21";
import Event22 from "./Event22";

const EventsWrapper = () => {
  const params = useParams();

  const { id } = params;

  if (id == 1) {
    return <Event1 />;
  } else if (id == 2) {
    return <Event2 />;
  } else if (id == 3) {
    return <Event3 />;
  } else if (id == 4) {
    return <Event4 />;
  } else if (id == 5) {
    return <Event5 />;
  } else if (id == 6) {
    return <Event6 />;
  } else if (id == 7) {
    return <Event7 />;
  } else if (id == 8) {
    return <Event8 />;
  } else if (id == 9) {
    return <Event9 />;
  } else if (id == 10) {
    return <Event10 />;
  } else if (id == 11) {
    return <Event11 />
  } else if(id == 12) {
    return <Event12 />
  } else if(id == 13) {
    return <Event13 />
  } else if(id == 14) {
    return <Event14 />
  }
  else if(id == 15) {
    return <Event15 />
  } else if(id == 16) {
    return <Event16 />
  } else if(id == 17) {
    return <Event17 />
  }
  else if(id == 18) {
    return <Event18 />
  } else if(id == 19) {
    return <Event19 />
  } else if(id == 20) {
    return <Event20 />
  } else if(id == 21) {
    return <Event21 />
  } else if(id == 22) {
    return <Event22 />
  }



  return <div>No News Found With this ID</div>;
};

export default EventsWrapper;
